import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import i18n, { setLocale } from './utils/i18n'
import { defaultLocale, languages } from './localisation/index'
import { useAppState } from './stores/AppState'
import { initializeAuth } from './authentication'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

import App from './App.vue'
import router, { setDynamicRoutes } from './router'

import discoveryService from './services/discovery'
import { start } from 'single-spa'
import { setupCalendar } from 'v-calendar'
import { showSplashScreen, showErrorPage } from './utils/splashScreen'
import { initialiseBranding, setThemeValues } from './utils/branding'

const messages = Object.assign(languages)

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  }
})

start()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
const appState = useAppState()

// watch(
//   pinia.state,
//   (state) => {
//     localStorage.setItem('discovery', JSON.stringify(state.discovery))
//   },
//   { deep: true }
// )

async function initializeApp() {
  try {
    await showSplashScreen()
    await appState.initialiseStore()

    const result = await discoveryService.getDiscovery()
    await handleDiscoveryResult(result)
  } catch (e) {
    await handleInitializationError(e)
  }
}

async function handleDiscoveryResult(result: any) {
  if (result && result.features.length > 0) {
    await setupApp(result)
  } else {
    throw new Error('No features found in discovery')
  }
}

async function handleInitializationError(e: any) {
  let errorMessage = `Unknown error during app initialization`
  let errorPage = 'errorPage.html'
  if (e) {
    errorMessage += `: ${(e as Error).message}`
    if ((e as Error).message === 'Unauthorized') {
      errorPage = 'unauthorized.html'
    }
  }
  console.error(errorMessage, e)
  await showErrorPage()
}

async function setupApp(result: any) {
  await appState.UpdateDiscovery(result)
  await setRoutes(result.features)
  await initializeAuth()

  const locale = result.branding?.locale || defaultLocale
  setLocale(locale)
  await initialiseBranding()
  await setThemeValues()

  app.use(i18n)
  app.use(router)
  app.use(vuetify)
  app.use(setupCalendar, {})

  app.mount('#app')
}

async function setRoutes(features: any[]) {
  const routes = await setDynamicRoutes(features)
  routes.forEach((route) => {
    if (route) {
      router.addRoute(route)
    }
  })
}

initializeApp()
